var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',{staticClass:"mt-4",attrs:{"dense":"","color":"transparent"}},[_c('v-list-item-group',{attrs:{"color":"primary"}},_vm._l((_vm.children),function(item,i){return _c('v-list-item',{key:i,attrs:{"to":{ name: item.route }}},[_c('v-list-item-content',[_c('v-list-item-title',{domProps:{"textContent":_vm._s(item.name)}})],1)],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }